module.exports = __webpack_public_path__ + "static/img/deposit.8792420d.png";